import React, { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Logo from "../../Images/logo1.png";
function Header() {
  const [expanded, setExpanded] = useState(false);
  const handleNavClick = () => setExpanded(false);
  const linkStyle = ({
    isActive
  }) => ({
    color: isActive ? "#6A20Af" : "#000",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "15px",
    fontFamily: "'Poppins', sans-serif"
  });
  return <Navbar expand="lg" expanded={expanded} className="py-1" style={{
    backgroundColor: "#f5f5f5",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
    minHeight: "70px"
  }}>
      <Container fluid className="px-3 px-md-4">
  
        <Navbar.Brand as={NavLink} to="/" className="m-0">
          <img src={Logo} alt="Sweepydo Logo" style={{
          height: "98px",
          width: "auto",
          objectFit: "contain"
        }} />
        </Navbar.Brand>

      
        <Navbar.Toggle onClick={() => setExpanded(!expanded)} className="d-lg-none border-0 shadow-none" aria-controls="basic-navbar-nav" style={{
        backgroundColor: expanded ? "#fff" : "#6A20Af",
        width: "50px",
        height: "36px",
        border: expanded ? "2px solid #6A20Af" : "none",
        borderRadius: "999px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0
      }}>
          {expanded ? <div style={{
          position: "relative",
          width: "20px",
          height: "20px"
        }}>
              <span style={{
            position: "absolute",
            top: "50%",
            left: 0,
            width: "100%",
            height: "3px",
            background: "#6A20Af",
            borderRadius: "3px",
            transform: "rotate(45deg)"
          }} />
              <span style={{
            position: "absolute",
            top: "50%",
            left: 0,
            width: "100%",
            height: "3px",
            background: "#6A20Af",
            borderRadius: "3px",
            transform: "rotate(-45deg)"
          }} />
            </div> : <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px"
        }}>
              <span style={{
            width: "18px",
            height: "3px",
            background: "#fff",
            borderRadius: "3px"
          }} />
              <span style={{
            width: "18px",
            height: "3px",
            background: "#fff",
            borderRadius: "3px"
          }} />
              <span style={{
            width: "10px",
            height: "3px",
            background: "#fff",
            borderRadius: "3px"
          }} />
            </div>}
        </Navbar.Toggle>

     
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto gap-4 mt-2 mt-lg-0 text-center align-items-lg-center">
            <Nav.Link as={NavLink} to="/" style={linkStyle} onClick={handleNavClick}>
              Home
            </Nav.Link>

            <Nav.Link as={NavLink} to="/about" style={linkStyle} onClick={handleNavClick}>
              About
            </Nav.Link>

            <Nav.Link as={NavLink} to="/services" style={linkStyle} onClick={handleNavClick}>
              Services
            </Nav.Link>

            <Nav.Link as={NavLink} to="/contact" style={linkStyle} onClick={handleNavClick}>
              Contact
            </Nav.Link>

               <Nav.Link as={NavLink} to="/hire-staff" style={linkStyle} onClick={handleNavClick}>
              Join Us
            </Nav.Link>
            
               <Nav.Link as={NavLink} to="/privacy-policy" style={linkStyle} onClick={handleNavClick}>
              Privacy Policy
            </Nav.Link>

             <Nav.Link as={NavLink} to="/term-and-condition" style={linkStyle} onClick={handleNavClick}>
             T&C
            </Nav.Link>
          </Nav>

     
          <div className="mt-2 mt-lg-0 d-flex justify-content-center">
      <a href="https://play.google.com/store/apps/details?id=com.dectwinservices.sweepydo&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
  <Button className="fw-bold border-0 px-4 py-1" style={{
              backgroundColor: "#c55DF8",
              color: "#000",
              borderRadius: "6px",
              fontFamily: "'Poppins', sans-serif",
              fontSize: "14px",
              height: "40px"
            }}>
   Donwload Now
    <ArrowRight size={18} className="ms-2" />
  </Button>
</a>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>;
}
export default Header;
